export const HERO_STYLES = {
  title:
    'xl:text-5xl lg:text-6xl text-5xl font-bold xl:leading-[60px] lg:leading-[70px] leading-[60px]',
  titleText:
    'xl:text-5xl lg:text-6xl text-5xl font-bold text-gray-900 xl:leading-[60px] lg:leading-[70px] leading-[60px]',
  titleHighlight:
    'xl:text-5xl lg:text-6xl text-5xl font-bold text-blue-300 xl:leading-[60px] lg:leading-[70px] leading-[60px]',
} as const;

export const HERO_CONTENT = {
  title: [
    { text: 'Reinventa', className: HERO_STYLES.titleText },
    { text: 'tus', className: HERO_STYLES.titleText },
    { text: 'campañas', className: HERO_STYLES.titleText },
    { text: 'de', className: HERO_STYLES.titleText },
    { text: 'moda', className: HERO_STYLES.titleText },
    { text: 'con', className: HERO_STYLES.titleText },
    { text: 'IA', className: HERO_STYLES.titleHighlight },
  ],
};
